import { createFileRoute } from '@tanstack/react-router';
import { ViewSubmissionScreen } from '@/quiz-submission/ViewSubmissionScreen';

/**
 * The member mount of the view screen, built once in `@/quiz-submission/`; this
 * file supplies the submission id.
 *
 * Keyed on the grading id, which is what every legacy link passes; a lesson
 * slug can't address a student's second submission for the same lesson.
 * `$memberId` is decorative: authorization is on the grading, not the path.
 */
export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/view/$submissionId',
)({
  component: MemberQuizSubmissionViewScreen,
});

function MemberQuizSubmissionViewScreen() {
  const { submissionId } = Route.useParams();
  return (
    <ViewSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
